var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('a',{attrs:{"href":"http://banidb.com/","target":"_blank"}},[_c('img',{attrs:{"alt":"BaniDB logo","src":require("../assets/logo.png")}})]),_c('h1',[_vm._v(" Welcome to anvaad-js (ਅਨੁਵਾਦ-ਜੇਐਸ) ")]),_c('p',[_vm._v("A JavaScript utility to transliterate gurmukhi, and convert it between ascii and unicode with ease!")])])
}]

export { render, staticRenderFns }